import React, { Component } from 'react'
import { HeroSectionTop, HeroSectionBottom } from 'components/HeroSections/HeroSections'
import MainContent from 'components/MainContent/MainContent'
import Footer from 'components/Footer/Footer'
import OffCanvas from 'components/OffCanvas/OffCanvas'
// import Invitation from "components/Invitation";

import { DataHeroSection } from 'components/Data/Data'

import 'assets/css/App.css'

class App extends Component {
  render() {
    const Data = DataHeroSection()
    return (
        <div className="sketchize-app">
          {/* <Invitation /> */}
          <OffCanvas />
          <HeroSectionTop title={Data.heroSection.top.title} description={Data.heroSection.top.description} />
          <MainContent />
          <HeroSectionBottom title={Data.heroSection.bottom.title} description={Data.heroSection.bottom.description} />
          <Footer />
        </div>
        
    )
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js